<template>
  <v-card>
    <v-data-table
      :headers="headersCrud"
      :items="dataCrud"
      v-model:expanded="expanded"
      item-key="index"
      show-expand
      dense
      hide-default-footer
      class="elevation-1 mx-auto pa-0 secundary5"
      style="width: 100%"
      @click:row="clickRowInfo"
    >
      <template v-slot:item[`index`]="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:top>
        <v-toolbar flat height="10" class="secundary5">
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="870px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                color="primary"
                x-small
                v-bind="attrs"
                v-on="on"
                width="25"
                height="25"
                class="mr-6"
                v-if="observerHCP === false"
              >
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card class="mt-13">
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text class="pb-0">
                <v-container>
                  <form>
                    <v-row>
                      <v-col
                        v-for="(field, index) in formCrud"
                        :key="index"
                        :cols="field.cols"
                        :sm="field.sm"
                        :md="field.md"
                        :lg="field.lg"
                        class="pb-1"
                      >
                        <component
                          :is="field.component"
                          :label="field.label"
                          :type="field.type"
                          :items="field.items"
                          v-bind="{ ...field.props }"
                          v-model="editedItem[field.vModel]"
                          @change="handleEvents"
                        ></component>
                      </v-col>
                      <span class="d-flex text-caption justify-end mx-4 mt-3 font-class-name">{{
                        spanMsg
                      }}</span>
                    </v-row>
                  </form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
                <v-btn color="blue darken-1" text @click="save"> Guardar </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="350px">
            <v-card>
              <v-card-title class="text-body-1">
                ¿Seguro que desea eliminar este item?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"> Cancelar </v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm(), remove()">
                  Eliminar
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-container v-if="isRouteFormExten === 'violenceFam'">
            <form class="ml-15 mb-5">
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
                  <span class="font-weight-medium">Violencia Económica [Int]: </span>
                  <span v-if="item.fam_viol_economic_int"> {{ item.fam_viol_economic_int }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
                  <span class="font-weight-medium">Violencia Psicológica [Int]: </span>
                  <span v-if="item.fam_viol_psychological_int">
                    {{ item.fam_viol_psychological_int }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
                  <span class="font-weight-medium">Violencia Física [Int]: </span>
                  <span v-if="item.fam_viol_physical_int"> {{ item.fam_viol_physical_int }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="pb-0">
                  <span class="font-weight-medium">Violencia Sexual [Int]: </span>
                  <span v-if="item.fam_viol_sexual_int"> {{ item.fam_viol_sexual_int }}</span>
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'substances'">
            <form class="ml-15 mb-5">
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Hábito: </span>
                  <span v-if="item.substance_habit_substance_habit_id">
                    {{ item.substance_habit_substance_habit_id.substance_habit }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Tiempo Cese: </span>
                  <span v-if="item.substance_cessation_time">
                    {{ item.substance_cessation_time.duration }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Abstinencia: </span>
                  <span v-if="item.substance_abstinence">
                    {{ item.substance_abstinence.option }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'violenceSoc'">
            <form class="ml-15 mb-5">
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="2" class="pb-0">
                  <span class="font-weight-medium">Viol. Económica [Int]: </span>
                  <span v-if="item.soc_viol_economic_int"> {{ item.soc_viol_economic_int }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="2" class="pb-0">
                  <span class="font-weight-medium">Viol. Psicológica [Int]: </span>
                  <span v-if="item.soc_viol_psychological_int">
                    {{ item.soc_viol_psychological_int }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="2" class="pb-0">
                  <span class="font-weight-medium">Viol. Física [Int]: </span>
                  <span v-if="item.soc_viol_physical_int"> {{ item.soc_viol_physical_int }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="2" class="pb-0">
                  <span class="font-weight-medium">Viol. Sexual [Int]: </span>
                  <span v-if="item.soc_viol_sexual_int"> {{ item.soc_viol_sexual_int }}</span>
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'academic'">
            <form class="ml-15 mb-5">
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Adaptabilidad: </span>
                  <span v-if="item.career_adaptability_level_description_id">
                    {{ item.career_adaptability_level_description_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Satisfacción: </span>
                  <span v-if="item.career_satisfaction_level_description_id">
                    {{ item.career_satisfaction_level_description_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Estrés: </span>
                  <span v-if="item.career_stress_level_description_id">
                    {{ item.career_stress_level_description_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="pb-0">
                  <span class="font-weight-medium">Relación con Pares: </span>
                  <span v-if="item.career_relation_peers_level_description_id">
                    {{ item.career_relation_peers_level_description_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="pb-0">
                  <span class="font-weight-medium">Relación con la Autoridad: </span>
                  <span v-if="item.career_relation_authority_level_description_id">
                    {{
                      item.career_relation_authority_level_description_id.level_description
                    }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'labor'">
            <form class="ml-15">
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Adaptabilidad: </span>
                  <span v-if="item.occupation_adaptability_level_description_id">
                    {{ item.occupation_adaptability_level_description_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Satisfacción: </span>
                  <span v-if="item.occupation_satisfaction_level_description_id">
                    {{ item.occupation_satisfaction_level_description_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Estrés: </span>
                  <span v-if="item.occupation_stress_level_description_id">
                    {{ item.occupation_stress_level_description_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">Relación con Pares: </span>
                  <span v-if="item.occupation_relation_peers_level_description_id">
                    {{
                      item.occupation_relation_peers_level_description_id.level_description
                    }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="4" class="pb-0 mb-7">
                  <span class="font-weight-medium">Relación con la Autoridad: </span>
                  <span v-if="item.occupation_relation_authority_level_description_id">
                    {{
                      item.occupation_relation_authority_level_description_id.level_description
                    }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'membersfam'">
            <form class="ml-15">
              <v-row v-if="item.bond">
                <v-col cols="12" sm="6" md="6" lg="3" class="pb-0">
                  <span class="font-weight-medium">N° Orden / N° Hermanos: </span>
                  {{ item.back_fam_sibling_order }}
                  <span v-if="item.back_fam_sibling_order || item.back_fam_sibling_num">/</span>
                  {{ item.back_fam_sibling_num }}
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Sexo Nacim.: </span>
                  <span v-if="item.back_fam_birth_sexes_id">
                    {{ item.back_fam_birth_sexes_id.birth_sexes }}</span
                  >
                  <span
                    v-if="item.back_fam_sex_transsexual && item.back_fam_sex_transsexual.id === 1"
                  >
                    (Ahora: Transexual)</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="2" class="pb-0">
                  <span class="font-weight-medium">Género: </span>
                  <span v-if="item.back_fam_genders_id">
                    {{ item.back_fam_genders_id.genders }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="3" class="pb-0">
                  <span class="font-weight-medium">Orientación: </span>
                  <span v-if="item.back_fam_sex_orientation_id">
                    {{ item.back_fam_sex_orientation_id.sex_orientation }}</span
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="8" class="pb-0">
                  <span class="font-weight-medium">Etapas Junto al Paciente: </span>
                  <span v-if="item.back_fam_development_stages">
                    <span v-for="(elem, index) in item.back_fam_development_stages" :key="index">
                      {{ elem.development_stages }}
                      <span class="mx-2" v-if="item.back_fam_development_stages[index + 1]"
                        >||</span
                      >
                    </span>
                  </span>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="4" class="pb-0">
                  <span class="font-weight-medium">Relación con Paciente: </span>
                  <span v-if="item.back_fam_relation_with_patient_level_description_id">
                    {{
                      item.back_fam_relation_with_patient_level_description_id.level_description
                    }}</span
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <span class="font-weight-medium">Lugar Nacimiento: </span>
                  <span v-if="item.back_fam_place_origin_iso3366">
                    {{ item.back_fam_place_origin_iso3366.ISO3366_1_comun_name }}
                    -
                  </span>
                  <span v-if="item.back_fam_place_origin_department">
                    {{ item.back_fam_place_origin_department.departments }} -
                  </span>
                  <span v-if="item.back_fam_place_origin_province">
                    {{ item.back_fam_place_origin_province.provinces }} -
                  </span>
                  <span v-if="item.back_fam_place_origin_district">
                    {{ item.back_fam_place_origin_district.districts }}
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <span class="font-weight-medium">Ocupación: </span>
                  <span v-for="(elem, index) in item.back_fam_member_occupation" :key="index">
                    {{ elem.occupation }}
                    <span class="mx-2" v-if="item.back_fam_member_occupation[index + 1]">||</span>
                  </span>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Edad Fallecimiento: </span>
                  <span v-if="item.back_fam_death_age">
                    {{ item.back_fam_death_age.age_interval }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Causa Fallecimiento: </span>
                  <span v-if="item.back_fam_death_causes_id">
                    {{ item.back_fam_death_causes_id.death_causes }}</span
                  >
                </v-col>
                <v-col cols="12" class="pb-0">
                  <span class="font-weight-medium">Enfermedades</span>
                  <span
                    v-if="item.back_fam_disease_diagnostic_manual"
                    class="text-caption font-weight-medium"
                  >
                    ({{ item.back_fam_disease_diagnostic_manual.diagnostic_manual }}):
                  </span>
                  <span v-for="(elem, index) in item.back_fam_member_disease" :key="index">
                    {{ elem.diagnostic_name }}
                    <span class="mx-4" v-if="item.back_fam_member_disease[index + 1]">||</span>
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <span class="font-weight-medium">Problemas Psic. o Psiq.</span>
                  <span
                    v-if="item.back_fam_mental_diagnostic_manual"
                    class="text-caption font-weight-medium"
                  >
                    ({{ item.back_fam_mental_diagnostic_manual.diagnostic_manual }}):
                  </span>
                  <span class="py-0" v-if="item.back_fam_member_mental_problem">
                    <span v-for="(elem, index) in item.back_fam_member_mental_problem" :key="index">
                      {{ elem.diagnostic_name }}
                      <span class="mx-4" v-if="item.back_fam_member_mental_problem[index + 1]"
                        >||</span
                      >
                    </span>
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <span class="font-weight-medium">Rasgos de Personalidad: </span>
                  <span v-for="(elem, index) in item.back_fam_member_trait" :key="index">
                    {{ elem.trait }}
                    <span class="mx-2" v-if="item.back_fam_member_trait[index + 1]">||</span>
                  </span>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="pb-0 mt-2">
                  <span class="font-weight-medium"> Parejas (con quién tiene hijos): </span>
                  <span v-if="item.back_fam_couple_total_num">
                    {{ item.back_fam_couple_total_num }}
                  </span>
                  <span v-if="item.i1_back_fam_couple_have">
                    <span
                      v-if="
                        item.i1_back_fam_couple_have.id === 2 ||
                        item.i1_back_fam_couple_have.id === null
                      "
                    >
                      No tiene.
                    </span>
                  </span>
                </v-col>
              </v-row>

              <v-row v-if="item.i1_back_fam_couple_have" class="mt-5 mb-6 ml-3">
                <v-row v-if="item.i1_back_fam_couple_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Pareja 1: </span>
                    <span v-if="item.i1_back_fam_couple_have">
                      <span v-if="item.i1_back_fam_couple_have.id === 2"> No tiene. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="2" class="py-0 pr-0 ml-3">
                    <span class="font-weight-medium">N° Orden: </span>
                    {{ item.i1_back_fam_couple_order }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Rama Fam.: </span>
                    <span v-if="item.i1_back_fam_couple_familiarity">
                      {{ item.i1_back_fam_couple_familiarity.couple_familiarity }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                    lg="3"
                    class="py-0 px-0 ml-xs-6 ml-sm-6"
                    v-if="item.i1_back_fam_relation_with_couple_id"
                  >
                    <span class="font-weight-medium">Relación con Pareja: </span>
                    {{ item.i1_back_fam_relation_with_couple_id.level_description }}
                  </v-col>
                  <v-col cols="12" md="12" lg="12" class="py-0 px-0 ml-6">
                    <span class="font-weight-medium">N° Hijos: </span>
                    <span class="ml-4"> Fem: {{ item.i1_back_fam_couple_sons_female }} </span>
                    <span class="mx-4"> || </span>
                    <span> Masc: {{ item.i1_back_fam_couple_sons_male }} </span>
                    <span class="mx-4"> || </span>
                    <span> Intersex: {{ item.i1_back_fam_couple_sons_intersex }} </span>
                  </v-col>
                  <v-col cols="12" class="py-0 ml-3">
                    <span class="font-weight-medium">Relación con Hijos: </span>
                    <span class="ml-2" v-if="item.i1_back_fam_couple_relation_with_son_1_id">
                      1° Hijo:
                      {{ item.i1_back_fam_couple_relation_with_son_1_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i1_back_fam_couple_relation_with_son_2_id">
                      2° Hijo:
                      {{ item.i1_back_fam_couple_relation_with_son_2_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i1_back_fam_couple_relation_with_son_3_id">
                      3° Hijo:
                      {{ item.i1_back_fam_couple_relation_with_son_3_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i1_back_fam_couple_relation_with_son_4_id">
                      4° Hijo:
                      {{ item.i1_back_fam_couple_relation_with_son_4_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i1_back_fam_couple_relation_with_son_5_id">
                      5° Hijo:
                      {{ item.i1_back_fam_couple_relation_with_son_5_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i1_back_fam_couple_relation_with_son_6_id">
                      6° Hijo:
                      {{ item.i1_back_fam_couple_relation_with_son_6_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i1_back_fam_couple_relation_with_son_7_id">
                      7° Hijo:
                      {{ item.i1_back_fam_couple_relation_with_son_7_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i1_back_fam_couple_relation_with_son_8_id">
                      8° Hijo:
                      {{ item.i1_back_fam_couple_relation_with_son_8_id.level_description }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i2_back_fam_couple_have" class="mb-6 ml-3">
                <v-row v-if="item.i2_back_fam_couple_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Pareja 2: </span>
                    <span v-if="item.i2_back_fam_couple_have">
                      <span v-if="item.i2_back_fam_couple_have.id === 2"> No tiene. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="2" class="py-0 pr-0 ml-3">
                    <span class="font-weight-medium">N° Orden: </span>
                    {{ item.i2_back_fam_couple_order }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Rama Fam.: </span>
                    <span v-if="item.i2_back_fam_couple_familiarity">
                      {{ item.i2_back_fam_couple_familiarity.couple_familiarity }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                    lg="3"
                    class="py-0 px-0 ml-xs-6 ml-sm-6"
                    v-if="item.i2_back_fam_relation_with_couple_id"
                  >
                    <span class="font-weight-medium">Relación con Pareja: </span>
                    {{ item.i2_back_fam_relation_with_couple_id.level_description }}
                  </v-col>
                  <v-col cols="12" md="12" lg="12" class="py-0 px-0 ml-6">
                    <span class="font-weight-medium">N° Hijos: </span>
                    <span class="ml-4"> Fem: {{ item.i2_back_fam_couple_sons_female }} </span>
                    <span class="mx-4"> || </span>
                    <span> Masc: {{ item.i2_back_fam_couple_sons_male }} </span>
                    <span class="mx-4"> || </span>
                    <span> Intersex: {{ item.i2_back_fam_couple_sons_intersex }} </span>
                  </v-col>
                  <v-col cols="12" class="py-0 ml-3">
                    <span class="font-weight-medium">Relación con Hijos: </span>
                    <span class="ml-2" v-if="item.i2_back_fam_couple_relation_with_son_1_id">
                      1° Hijo:
                      {{ item.i2_back_fam_couple_relation_with_son_1_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i2_back_fam_couple_relation_with_son_2_id">
                      2° Hijo:
                      {{ item.i2_back_fam_couple_relation_with_son_2_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i2_back_fam_couple_relation_with_son_3_id">
                      3° Hijo:
                      {{ item.i2_back_fam_couple_relation_with_son_3_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i2_back_fam_couple_relation_with_son_4_id">
                      4° Hijo:
                      {{ item.i2_back_fam_couple_relation_with_son_4_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i2_back_fam_couple_relation_with_son_5_id">
                      5° Hijo:
                      {{ item.i2_back_fam_couple_relation_with_son_5_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i2_back_fam_couple_relation_with_son_6_id">
                      6° Hijo:
                      {{ item.i2_back_fam_couple_relation_with_son_6_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i2_back_fam_couple_relation_with_son_7_id">
                      7° Hijo:
                      {{ item.i2_back_fam_couple_relation_with_son_7_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i2_back_fam_couple_relation_with_son_8_id">
                      8° Hijo:
                      {{ item.i2_back_fam_couple_relation_with_son_8_id.level_description }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i3_back_fam_couple_have" class="mb-6 ml-3">
                <v-row v-if="item.i3_back_fam_couple_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Pareja 3: </span>
                    <span v-if="item.i3_back_fam_couple_have">
                      <span v-if="item.i3_back_fam_couple_have.id === 2"> No tiene. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="2" class="py-0 pr-0 ml-3">
                    <span class="font-weight-medium">N° Orden: </span>
                    {{ item.i3_back_fam_couple_order }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Rama Fam.: </span>
                    <span v-if="item.i3_back_fam_couple_familiarity">
                      {{ item.i3_back_fam_couple_familiarity.couple_familiarity }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                    lg="3"
                    class="py-0 px-0 ml-xs-6 ml-sm-6"
                    v-if="item.i3_back_fam_relation_with_couple_id"
                  >
                    <span class="font-weight-medium">Relación con Pareja: </span>
                    {{ item.i3_back_fam_relation_with_couple_id.level_description }}
                  </v-col>
                  <v-col cols="12" md="12" lg="12" class="py-0 px-0 ml-6">
                    <span class="font-weight-medium">N° Hijos: </span>
                    <span class="ml-4"> Fem: {{ item.i3_back_fam_couple_sons_female }} </span>
                    <span class="mx-4"> || </span>
                    <span> Masc: {{ item.i3_back_fam_couple_sons_male }} </span>
                    <span class="mx-4"> || </span>
                    <span> Intersex: {{ item.i3_back_fam_couple_sons_intersex }} </span>
                  </v-col>
                  <v-col cols="12" class="py-0 ml-3">
                    <span class="font-weight-medium">Relación con Hijos: </span>
                    <span class="ml-2" v-if="item.i3_back_fam_couple_relation_with_son_1_id">
                      1° Hijo:
                      {{ item.i3_back_fam_couple_relation_with_son_1_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i3_back_fam_couple_relation_with_son_2_id">
                      2° Hijo:
                      {{ item.i3_back_fam_couple_relation_with_son_2_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i3_back_fam_couple_relation_with_son_3_id">
                      3° Hijo:
                      {{ item.i3_back_fam_couple_relation_with_son_3_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i3_back_fam_couple_relation_with_son_4_id">
                      4° Hijo:
                      {{ item.i3_back_fam_couple_relation_with_son_4_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i3_back_fam_couple_relation_with_son_5_id">
                      5° Hijo:
                      {{ item.i3_back_fam_couple_relation_with_son_5_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i3_back_fam_couple_relation_with_son_6_id">
                      6° Hijo:
                      {{ item.i3_back_fam_couple_relation_with_son_6_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i3_back_fam_couple_relation_with_son_7_id">
                      7° Hijo:
                      {{ item.i3_back_fam_couple_relation_with_son_7_id.level_description }}
                      <span class="mx-md-2 mx-lg-6"> || </span>
                    </span>
                    <span class="ml-2" v-if="item.i3_back_fam_couple_relation_with_son_8_id">
                      8° Hijo:
                      {{ item.i3_back_fam_couple_relation_with_son_8_id.level_description }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'acadBasic'">
            <form class="ml-15">
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Adaptabilidad: </span>
                  <span v-if="item.back_academ_adaptation_level_id">
                    {{ item.back_academ_adaptation_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Relación con Pares: </span>
                  <span v-if="item.back_academ_relationship_peer_level_id">
                    {{ item.back_academ_relationship_peer_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">N° Agresiones a Pares: </span>
                  <span v-if="item.back_academ_aggressions_peers_num">
                    {{ item.back_academ_aggressions_peers_num }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Bullying (Veces): </span>
                  <span class="font-weight-medium ml-3">Victima: </span>
                  <span v-if="item.back_academ_bullying_victim">
                    {{ item.back_academ_bullying_victim }}</span
                  >
                  <span class="font-weight-medium ml-3">Agresor: </span>
                  <span v-if="item.back_academ_bullying_aggressor">
                    {{ item.back_academ_bullying_aggressor }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Relac. con la Autoridad: </span>
                  <span v-if="item.back_academ_relationship_authority_level_id">
                    {{ item.back_academ_relationship_authority_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">N° Agresiones a la Autoridad: </span>
                  <span v-if="item.back_academ_aggressions_authority_num">
                    {{ item.back_academ_aggressions_authority_num }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">N° Suspensiones: </span>
                  <span v-if="item.back_academ_suspensions_num">
                    {{ item.back_academ_suspensions_num }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Rendimiento: </span>
                  <span v-if="item.back_academ_performance_level_id">
                    {{ item.back_academ_performance_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0 mb-5">
                  <span class="font-weight-medium">N° Repitencias: </span>
                  <span v-if="item.back_academ_repetitions_year_num">
                    {{ item.back_academ_repetitions_year_num }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'acadSuperior'">
            <form class="ml-15">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Estado: </span>
                  <span v-if="item.career_condition_career_condition_id">
                    {{ item.career_condition_career_condition_id.career_condition }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Año de Instrucción: </span>
                  <span v-if="item.back_academ_career_instruction_year_code">
                    {{ item.back_academ_career_instruction_year_code.instruction_years }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Adaptabilidad: </span>
                  <span v-if="item.back_academ_career_adaptation_level_id">
                    {{ item.back_academ_career_adaptation_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Relación con Pares: </span>
                  <span v-if="item.back_academ_career_relationship_peer_level_id">
                    {{ item.back_academ_career_relationship_peer_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="pb-0">
                  <span class="font-weight-medium">Bullying (N° Veces): </span>
                  <span class="font-weight-medium ml-3">Victima: </span>
                  <span v-if="item.back_academ_career_bullying_victim">
                    {{ item.back_academ_career_bullying_victim }}</span
                  >
                  <span class="font-weight-medium ml-3">Agresor: </span>
                  <span v-if="item.back_academ_career_bullying_aggressor">
                    {{ item.back_academ_career_bullying_aggressor }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4" class="pb-0">
                  <span class="font-weight-medium">Relación con la Autoridad: </span>
                  <span v-if="item.back_academ_career_relationship_authority_level_id">
                    {{
                      item.back_academ_career_relationship_authority_level_id.level_description
                    }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Rendimiento: </span>
                  <span v-if="item.back_academ_career_performance_level_id">
                    {{ item.back_academ_career_performance_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Cursos Reprobados: </span>
                  <span v-if="item.back_academ_career_failed_courses">
                    {{ item.back_academ_career_failed_courses }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" class="pb-0 mb-5">
                  <span class="font-weight-medium">Satisfacción: </span>
                  <span v-if="item.back_academ_career_satisfaction">
                    {{ item.back_academ_career_satisfaction.level_description }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'jobs'">
            <form class="ml-15">
              <v-row>
                <v-col cols="12" sm="6" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">Duración: </span>
                  <span v-if="item.back_labor_duration_id">
                    {{ item.back_labor_duration_id.duration }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="6" class="pb-0">
                  <span class="font-weight-medium">Adaptabilidad: </span>
                  <span v-if="item.back_labor_adaptation_level_id">
                    {{ item.back_labor_adaptation_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">Relación con Pares: </span>
                  <span v-if="item.back_labor_relationship_peer_level_id">
                    {{ item.back_labor_relationship_peer_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="7" lg="6" class="pb-0">
                  <span class="font-weight-medium">Mobbing (N° Veces): </span>
                  <span class="font-weight-medium ml-3">Victima: </span>
                  <span v-if="item.back_labor_mobbing_victim">
                    {{ item.back_labor_mobbing_victim }}</span
                  >
                  <span class="font-weight-medium ml-3">Agresor: </span>
                  <span v-if="item.back_labor_mobbing_aggressor">
                    {{ item.back_labor_mobbing_aggressor }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">Relación con la Autoridad: </span>
                  <span v-if="item.back_labor_relationship_authority_level_id">
                    {{ item.back_labor_relationship_authority_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Rendimiento: </span>
                  <span v-if="item.back_labor_performance_level_id">
                    {{ item.back_labor_performance_level_id.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="pb-0">
                  <span class="font-weight-medium">Satisfacción: </span>
                  <span v-if="item.back_labor_satisfaction">
                    {{ item.back_labor_satisfaction.level_description }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">Salida: </span>
                  <span v-if="item.labor_leave_labor_leave_id">
                    {{ item.labor_leave_labor_leave_id.labor_leave }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="7" lg="5" class="pb-0 mb-5">
                  <span class="font-weight-medium">Motivo de Salida: </span>
                  <span v-if="item.labor_leave_why_labor_leave_why_id">
                    {{ item.labor_leave_why_labor_leave_why_id.labor_leave_why }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'mental'">
            <form class="ml-15">
              <v-row>
                <v-col cols="12" sm="12" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Duración: </span>
                  <span v-if="item.back_mental_duration_id">
                    {{ item.back_mental_duration_id.duration }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Internamiento: </span>
                  <span v-if="item.back_mental_internment">
                    {{ item.back_mental_internment.option }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Inter. Duración: </span>
                  <span v-if="item.back_mental_internment_duration_id">
                    {{ item.back_mental_internment_duration_id.duration }}</span
                  >
                </v-col>
                <v-col cols="12" class="mb-2">
                  <span class="font-weight-medium"
                    >Tiempo de Remisión Posterior (al cuadro clínico):
                  </span>
                  <span v-if="item.back_mental_trp_duration_id">
                    {{ item.back_mental_trp_duration_id.duration }}</span
                  >
                </v-col>
              </v-row>

              <v-row v-if="item.i1_back_terapy_mental_have" class="mb-6 ml-3">
                <v-row v-if="item.i1_back_terapy_mental_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 1: </span>
                    <span v-if="item.i1_back_terapy_mental_have">
                      <span v-if="item.i1_back_terapy_mental_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-3">N° Orden: </span>
                    {{ item.i1_back_terapy_mental_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i1_back_terapy_mental_type">
                      {{ item.i1_back_terapy_mental_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i1_back_terapy_mental_age_beginning">
                      {{ item.i1_back_terapy_mental_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i1_back_terapy_mental_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Duración: </span>
                    <span v-if="item.i1_back_terapy_mental_duration_id">
                      {{ item.i1_back_terapy_mental_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i1_back_terapy_mental_compliance_int">
                      {{ item.i1_back_terapy_mental_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i2_back_terapy_mental_have" class="mb-6 ml-3">
                <v-row v-if="item.i2_back_terapy_mental_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 2: </span>
                    <span v-if="item.i2_back_terapy_mental_have">
                      <span v-if="item.i2_back_terapy_mental_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-3">N° Orden: </span>
                    {{ item.i2_back_terapy_mental_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i2_back_terapy_mental_type">
                      {{ item.i2_back_terapy_mental_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i2_back_terapy_mental_age_beginning">
                      {{ item.i2_back_terapy_mental_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i2_back_terapy_mental_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Duración: </span>
                    <span v-if="item.i2_back_terapy_mental_duration_id">
                      {{ item.i2_back_terapy_mental_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i2_back_terapy_mental_compliance_int">
                      {{ item.i2_back_terapy_mental_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i3_back_terapy_mental_have" class="mb-6 ml-3">
                <v-row v-if="item.i3_back_terapy_mental_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 3: </span>
                    <span v-if="item.i3_back_terapy_mental_have">
                      <span v-if="item.i3_back_terapy_mental_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-3">N° Orden: </span>
                    {{ item.i3_back_terapy_mental_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i3_back_terapy_mental_type">
                      {{ item.i3_back_terapy_mental_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i3_back_terapy_mental_age_beginning">
                      {{ item.i3_back_terapy_mental_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i3_back_terapy_mental_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Duración: </span>
                    <span v-if="item.i3_back_terapy_mental_duration_id">
                      {{ item.i3_back_terapy_mental_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i3_back_terapy_mental_compliance_int">
                      {{ item.i3_back_terapy_mental_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i4_back_terapy_mental_have" class="mb-6 ml-3">
                <v-row v-if="item.i4_back_terapy_mental_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 4: </span>
                    <span v-if="item.i4_back_terapy_mental_have">
                      <span v-if="item.i4_back_terapy_mental_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-3">N° Orden: </span>
                    {{ item.i4_back_terapy_mental_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i4_back_terapy_mental_type">
                      {{ item.i4_back_terapy_mental_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i4_back_terapy_mental_age_beginning">
                      {{ item.i4_back_terapy_mental_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i4_back_terapy_mental_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Duración: </span>
                    <span v-if="item.i4_back_terapy_mental_duration_id">
                      {{ item.i4_back_terapy_mental_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i4_back_terapy_mental_compliance_int">
                      {{ item.i4_back_terapy_mental_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i5_back_terapy_mental_have" class="mb-6 ml-3">
                <v-row v-if="item.i5_back_terapy_mental_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 5: </span>
                    <span v-if="item.i5_back_terapy_mental_have">
                      <span v-if="item.i5_back_terapy_mental_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-3">N° Orden: </span>
                    {{ item.i5_back_terapy_mental_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i5_back_terapy_mental_type">
                      {{ item.i5_back_terapy_mental_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i5_back_terapy_mental_age_beginning">
                      {{ item.i5_back_terapy_mental_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i5_back_terapy_mental_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Duración: </span>
                    <span v-if="item.i5_back_terapy_mental_duration_id">
                      {{ item.i5_back_terapy_mental_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i5_back_terapy_mental_compliance_int">
                      {{ item.i5_back_terapy_mental_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i6_back_terapy_mental_have" class="mb-6 ml-3">
                <v-row v-if="item.i6_back_terapy_mental_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 6: </span>
                    <span v-if="item.i6_back_terapy_mental_have">
                      <span v-if="item.i6_back_terapy_mental_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0 ml-3">
                    <span class="font-weight-medium">N° Orden: </span>
                    {{ item.i6_back_terapy_mental_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i6_back_terapy_mental_type">
                      {{ item.i6_back_terapy_mental_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i6_back_terapy_mental_age_beginning">
                      {{ item.i6_back_terapy_mental_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i6_back_terapy_mental_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Duración: </span>
                    <span v-if="item.i6_back_terapy_mental_duration_id">
                      {{ item.i6_back_terapy_mental_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i6_back_terapy_mental_compliance_int">
                      {{ item.i6_back_terapy_mental_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'medical'">
            <form class="ml-15">
              <v-row>
                <v-col cols="12" sm="12" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Duración: </span>
                  <span v-if="item.back_medical_duration_id">
                    {{ item.back_medical_duration_id.duration }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2" class="pb-0">
                  <span class="font-weight-medium">Hospitalización: </span>
                  <span v-if="item.back_medical_hospitaliz">
                    {{ item.back_medical_hospitaliz.option }}</span
                  >
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Hospitaliz. Duración: </span>
                  <span v-if="item.back_medical_hospitaliz_duration_id">
                    {{ item.back_medical_hospitaliz_duration_id.duration }}</span
                  >
                </v-col>
                <v-col cols="12" lg="2" class="mb-2">
                  <span class="font-weight-medium">Cirugía: </span>
                  <span v-if="item.back_medical_surgery">
                    {{ item.back_medical_surgery.option }}</span
                  >
                </v-col>
              </v-row>

              <v-row v-if="item.i1_back_terapy_medical_have" class="mb-6 ml-3">
                <v-row v-if="item.i1_back_terapy_medical_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 1: </span>
                    <span v-if="item.i1_back_terapy_medical_have">
                      <span v-if="item.i1_back_terapy_medical_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-3">N° Orden: </span>
                    {{ item.i1_back_terapy_medical_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i1_back_terapy_medical_type">
                      {{ item.i1_back_terapy_medical_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i1_back_terapy_medical_age_beginning">
                      {{ item.i1_back_terapy_medical_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i1_back_terapy_medical_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="5" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0 ml-lg-6">Duración: </span>
                    <span v-if="item.i1_back_terapy_medical_duration_id">
                      {{ item.i1_back_terapy_medical_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i1_back_terapy_medical_compliance_int">
                      {{ item.i1_back_terapy_medical_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i2_back_terapy_medical_have" class="mb-6 ml-3">
                <v-row v-if="item.i2_back_terapy_medical_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 2: </span>
                    <span v-if="item.i2_back_terapy_medical_have">
                      <span v-if="item.i2_back_terapy_medical_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-3">N° Orden: </span>
                    {{ item.i2_back_terapy_medical_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i2_back_terapy_medical_type">
                      {{ item.i2_back_terapy_medical_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i2_back_terapy_medical_age_beginning">
                      {{ item.i2_back_terapy_medical_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i2_back_terapy_medical_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="5" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0 ml-lg-6">Duración: </span>
                    <span v-if="item.i2_back_terapy_medical_duration_id">
                      {{ item.i2_back_terapy_medical_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i2_back_terapy_medical_compliance_int">
                      {{ item.i2_back_terapy_medical_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i3_back_terapy_medical_have" class="mb-6 ml-3">
                <v-row v-if="item.i3_back_terapy_medical_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 3: </span>
                    <span v-if="item.i3_back_terapy_medical_have">
                      <span v-if="item.i3_back_terapy_medical_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-3">N° Orden: </span>
                    {{ item.i3_back_terapy_medical_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i3_back_terapy_medical_type">
                      {{ item.i3_back_terapy_medical_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i3_back_terapy_medical_age_beginning">
                      {{ item.i3_back_terapy_medical_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i3_back_terapy_medical_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="5" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0 ml-lg-6">Duración: </span>
                    <span v-if="item.i3_back_terapy_medical_duration_id">
                      {{ item.i3_back_terapy_medical_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i3_back_terapy_medical_compliance_int">
                      {{ item.i3_back_terapy_medical_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i4_back_terapy_medical_have" class="mb-6 ml-3">
                <v-row v-if="item.i4_back_terapy_medical_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 4: </span>
                    <span v-if="item.i4_back_terapy_medical_have">
                      <span v-if="item.i4_back_terapy_medical_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-3">N° Orden: </span>
                    {{ item.i4_back_terapy_medical_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i4_back_terapy_medical_type">
                      {{ item.i4_back_terapy_medical_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i4_back_terapy_medical_age_beginning">
                      {{ item.i4_back_terapy_medical_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i4_back_terapy_medical_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="5" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0 ml-lg-6">Duración: </span>
                    <span v-if="item.i4_back_terapy_medical_duration_id">
                      {{ item.i4_back_terapy_medical_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i4_back_terapy_medical_compliance_int">
                      {{ item.i4_back_terapy_medical_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i5_back_terapy_medical_have" class="mb-6 ml-3">
                <v-row v-if="item.i5_back_terapy_medical_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 5: </span>
                    <span v-if="item.i5_back_terapy_medical_have">
                      <span v-if="item.i5_back_terapy_medical_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-3">N° Orden: </span>
                    {{ item.i5_back_terapy_medical_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i5_back_terapy_medical_type">
                      {{ item.i5_back_terapy_medical_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i5_back_terapy_medical_age_beginning">
                      {{ item.i5_back_terapy_medical_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i5_back_terapy_medical_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="5" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0 ml-lg-6">Duración: </span>
                    <span v-if="item.i5_back_terapy_medical_duration_id">
                      {{ item.i5_back_terapy_medical_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i5_back_terapy_medical_compliance_int">
                      {{ item.i5_back_terapy_medical_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i6_back_terapy_medical_have" class="mb-6 ml-3">
                <v-row v-if="item.i6_back_terapy_medical_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Terapia 6: </span>
                    <span v-if="item.i6_back_terapy_medical_have">
                      <span v-if="item.i6_back_terapy_medical_have.id === 2"> No tuvo. </span>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="5" md="3" class="py-0 pr-0 ml-3">
                    <span class="font-weight-medium">N° Orden: </span>
                    {{ item.i6_back_terapy_medical_professionals_num }}
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Tipo: </span>
                    <span v-if="item.i6_back_terapy_medical_type">
                      {{ item.i6_back_terapy_medical_type.terapy_type }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0">Edad Inicio: </span>
                    <span v-if="item.i6_back_terapy_medical_age_beginning">
                      {{ item.i6_back_terapy_medical_age_beginning.age_interval }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" class="py-0 pr-0">
                    <span class="font-weight-medium ml-md-3">N° Sesiones: </span>
                    {{ item.i6_back_terapy_medical_sessions_num }}
                  </v-col>
                  <v-col cols="12" sm="7" md="4" lg="5" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6 ml-sm-6 ml-md-0 ml-lg-6">Duración: </span>
                    <span v-if="item.i6_back_terapy_medical_duration_id">
                      {{ item.i6_back_terapy_medical_duration_id.duration }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="3" lg="3" class="py-0 px-0">
                    <span class="font-weight-medium ml-xs-6">Cumplimiento (int): </span>
                    <span v-if="item.i6_back_terapy_medical_compliance_int">
                      {{ item.i6_back_terapy_medical_compliance_int }}
                    </span>
                  </v-col>
                </v-row>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'drugs'">
            <form class="ml-15">
              <v-row>
                <v-col cols="12" sm="12" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Duración: </span>
                  <span v-if="item.back_drugs_duration_id">
                    {{ item.back_drugs_duration_id.duration }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">Frecuencia: </span>
                  <span v-if="item.back_drugs_frequency_id">
                    {{ item.back_drugs_frequency_id.frequency }}</span
                  >
                </v-col>
                <v-col cols="12" sm="5" md="3" lg="4" class="pb-0">
                  <span class="font-weight-medium">Recetado: </span>
                  <span v-if="item.back_drugs_prescribed">
                    {{ item.back_drugs_prescribed.option }}</span
                  >
                </v-col>
                <v-col cols="12" sm="5" md="3" lg="4" class="pb-0">
                  <span class="font-weight-medium">N° Sobredosis: </span>
                  <span v-if="item.back_drugs_overdose_num">
                    {{ item.back_drugs_overdose_num }}</span
                  >
                </v-col>
                <v-col cols="12" sm="7" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Hábito: </span>
                  <span v-if="item.back_drugs_substance_habit_id">
                    {{ item.back_drugs_substance_habit_id.substance_habit }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">Conciencia de Problema (Int): </span>
                  <span v-if="item.back_drugs_consciousness_int">
                    {{ item.back_drugs_consciousness_int.intensity }}</span
                  >
                </v-col>
                <v-col cols="12" sm="5" md="3" lg="4" class="pb-0">
                  <span class="font-weight-medium">N° Detox: </span>
                  <span v-if="item.back_drugs_detox_num"> {{ item.back_drugs_detox_num }}</span>
                </v-col>
                <v-col cols="12" sm="7" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Síndrome Abstinencia: </span>
                  <span v-if="item.back_drugs_abstinence_syndrome">
                    {{ item.back_drugs_abstinence_syndrome.option }}</span
                  >
                </v-col>
                <v-col cols="12" sm="5" md="3" lg="4" class="pb-0">
                  <span class="font-weight-medium">Internamiento: </span>
                  <span v-if="item.back_drugs_internment">
                    {{ item.back_drugs_internment.option }}</span
                  >
                </v-col>
                <v-col cols="12" sm="7" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">Inter. Duración: </span>
                  <span v-if="item.back_drugs_internment_duration_id">
                    {{ item.back_drugs_internment_duration_id.duration }}</span
                  >
                </v-col>
                <v-col cols="12" class="mb-2">
                  <span class="font-weight-medium"
                    >Tiempo de Remisión Posterior (al cuadro clínico):
                  </span>
                  <span v-if="item.back_drugs_trp_duration_id">
                    {{ item.back_drugs_trp_duration_id.duration }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'violence'">
            <form class="ml-15 mb-5">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <span class="font-weight-medium">Tipo de Violencia: </span>
                  <span v-for="(elem, index) in item.back_violence_type" :key="index">
                    {{ elem.violence_type }}
                    <span class="mx-2" v-if="item.back_violence_type[index + 1]">||</span>
                  </span>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <span class="font-weight-medium">Observaciones: </span>
                  <span v-if="item.back_violence_observation">
                    {{ item.back_violence_observation }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'criminal'">
            <form class="ml-15 mb-8">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0">
                  <span class="font-weight-medium">Arma: </span>
                  <span v-if="item.back_crime_weapon_id">
                    {{ item.back_crime_weapon_id.crime_weapon }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="pb-0">
                  <span class="font-weight-medium">Intervención: </span>
                  <span v-if="item.back_crime_intervention_id">
                    {{ item.back_crime_intervention_id.crime_intervention }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="pb-0">
                  <span class="font-weight-medium">Duración de Intervención: </span>
                  <span v-if="item.back_crime_intervention_duration_id">
                    {{ item.back_crime_intervention_duration_id.duration }}</span
                  >
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="pb-0 mt-2">
                  <span class="font-weight-medium"> N° Víctimas: </span>
                  <span v-if="item.back_crime_victim_total_num && item.back_crime_victim_total_num > 0">
                    {{ item.back_crime_victim_total_num }}
                  </span>
                  <span v-if="item.i1_back_crime_victim_have">
                    <span
                      v-if="
                        item.i1_back_crime_victim_have.id === 2 ||
                        item.i1_back_crime_victim_have.id === null
                      "
                    >
                      No hubo.
                    </span>
                  </span>
                </v-col>
              </v-row>

              <v-row v-if="item.i1_back_crime_victim_have" class="mt-3 ml-3">
                <v-row v-if="item.i1_back_crime_victim_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Víctima 1: </span>
                    <span v-if="item.i1_back_crime_victim_have">
                      <span v-if="item.i1_back_crime_victim_have.id === 2"> No hubo. </span>
                    </span>
                    <span v-if="item.i1_back_crime_victim_name">
                      {{ item.i1_back_crime_victim_name }}
                    </span>
                    <span v-if="item.i1_back_crime_victim_bond_id">
                      --[ {{ item.i1_back_crime_victim_bond_id.bond }} ]
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i2_back_crime_victim_have" class="mt-3 ml-3">
                <v-row v-if="item.i2_back_crime_victim_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Víctima 2: </span>
                    <span v-if="item.i2_back_crime_victim_have">
                      <span v-if="item.i2_back_crime_victim_have.id === 2"> No hubo. </span>
                    </span>
                    <span v-if="item.i2_back_crime_victim_name">
                      {{ item.i2_back_crime_victim_name }}
                    </span>
                    <span>--[ </span>
                    <span v-if="item.i2_back_crime_victim_bond_id">
                      {{ item.i2_back_crime_victim_bond_id.bond }}
                    </span>
                    <span> ]</span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i3_back_crime_victim_have" class="mt-3 ml-3">
                <v-row v-if="item.i3_back_crime_victim_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Víctima 3: </span>
                    <span v-if="item.i3_back_crime_victim_have">
                      <span v-if="item.i3_back_crime_victim_have.id === 2"> No hubo. </span>
                    </span>
                    <span v-if="item.i3_back_crime_victim_name">
                      {{ item.i3_back_crime_victim_name }}
                    </span>
                    <span>--[ </span>
                    <span v-if="item.i3_back_crime_victim_bond_id">
                      {{ item.i3_back_crime_victim_bond_id.bond }}
                    </span>
                    <span> ]</span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i4_back_crime_victim_have" class="mt-3 ml-3">
                <v-row v-if="item.i4_back_crime_victim_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Víctima 4: </span>
                    <span v-if="item.i4_back_crime_victim_have">
                      <span v-if="item.i4_back_crime_victim_have.id === 2"> No hubo. </span>
                    </span>
                    <span v-if="item.i4_back_crime_victim_name">
                      {{ item.i4_back_crime_victim_name }}
                    </span>
                    <span>--[ </span>
                    <span v-if="item.i4_back_crime_victim_bond_id">
                      {{ item.i4_back_crime_victim_bond_id.bond }}
                    </span>
                    <span> ]</span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i5_back_crime_victim_have" class="mt-3 ml-3">
                <v-row v-if="item.i5_back_crime_victim_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Víctima 5: </span>
                    <span v-if="item.i5_back_crime_victim_have">
                      <span v-if="item.i5_back_crime_victim_have.id === 2"> No hubo. </span>
                    </span>
                    <span v-if="item.i5_back_crime_victim_name">
                      {{ item.i5_back_crime_victim_name }}
                    </span>
                    <span>--[ </span>
                    <span v-if="item.i5_back_crime_victim_bond_id">
                      {{ item.i5_back_crime_victim_bond_id.bond }}
                    </span>
                    <span> ]</span>
                  </v-col>
                </v-row>
              </v-row>

              <v-row v-if="item.i6_back_crime_victim_have" class="mt-3 ml-3">
                <v-row v-if="item.i6_back_crime_victim_have.id === 1">
                  <v-col cols="12" class="pb-0 mt-3">
                    <span class="font-weight-medium"> Víctima 6: </span>
                    <span v-if="item.i6_back_crime_victim_have">
                      <span v-if="item.i6_back_crime_victim_have.id === 2"> No hubo. </span>
                    </span>
                    <span v-if="item.i6_back_crime_victim_name">
                      {{ item.i6_back_crime_victim_name }}
                    </span>
                    <span>--[ </span>
                    <span v-if="item.i6_back_crime_victim_bond_id">
                      {{ item.i6_back_crime_victim_bond_id.bond }}
                    </span>
                    <span> ]</span>
                  </v-col>
                </v-row>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'medications'">
            <form class="ml-15 mb-6">
              <v-row>
                <v-col cols="12" sm="7" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Concentración: </span>
                  <span v-if="item.back_medication_concentration">
                    {{ item.back_medication_concentration }}</span
                  >
                </v-col>
                <v-col cols="12" sm="5" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">Dosis: </span>
                  <span v-if="item.back_medication_dose"> {{ item.back_medication_dose }}</span>
                </v-col>
                <v-col cols="12" sm="7" md="4" lg="4" class="pb-0">
                  <span class="font-weight-medium">Duración: </span>
                  <span v-if="item.back_medication_duration">
                    {{ item.back_medication_duration.duration }}</span
                  >
                </v-col>
                <v-col cols="12" sm="5" md="3" lg="4" class="pb-0">
                  <span class="font-weight-medium">Vía: </span>
                  <span v-if="item.back_medication_route">
                    {{ item.back_medication_route.medication_route }}</span
                  >
                </v-col>
                <v-col cols="12" sm="7" md="5" lg="4" class="pb-0">
                  <span class="font-weight-medium">Cumplimiento (Int): </span>
                  <span v-if="item.back_medication_compliance_int">
                    {{ item.back_medication_compliance_int }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'relevant-events'">
            <form class="ml-15 mb-6">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <span class="font-weight-medium">Descripción: </span>
                  <span v-if="item.back_relevant_events_description">
                    {{ item.back_relevant_events_description }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
          <v-container v-if="isRouteFormExten === 'diagTreatment'">
            <form class="ml-15 mb-6">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0">
                  <span class="font-weight-medium">Derivación: </span>
                  <span v-if="item.treatment_derivation_treatment_derivation_id">
                    {{
                      item.treatment_derivation_treatment_derivation_id.treatment_derivation
                    }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="8" class="pb-0">
                  <span class="font-weight-medium">Institución: </span>
                  <span v-if="item.treatment_institution_code">
                    {{ item.treatment_institution_code.institutions }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="4" class="pb-0">
                  <span class="font-weight-medium">Servicio: </span>
                  <span v-if="item.treatment_health_services_code">
                    {{ item.treatment_health_services_code.health_services }}</span
                  >
                </v-col>
              </v-row>
            </form>
          </v-container>
        </td>
      </template>
      <template v-slot:[`item.actions`]="{ item }" v-if="observerHCP === false">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Reset </v-btn>
      </template>
    </v-data-table>
    <v-col cols="12" class="d-flex justify-end secundary5" v-if="isRouteCheckbox">
      <v-checkbox
        :input-value="checkboxNone"
        @change="handleEventsbox"
        label="Ninguno"
        hide-details
        v-if="observerHCP === false"
      ></v-checkbox>
      <v-checkbox
        :value="checkboxNone"
        :readonly="true"
        :ripple="false"
        label="Ninguno"
        color="primary"
        hide-details
        v-else
      ></v-checkbox>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: 'VCrudExpandable',
  props: [
    'headersCrud',
    'dataCrud',
    'formCrud',
    'editedItems',
    'defaultItems',
    'handleEvents',
    'spanMsg',
    'checkboxNone',
    'handleEventsbox',
    'clickRowInfo',
    'remove',
    'observerHCP',
  ],
  data() {
    return {
      expanded: [],
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Ingresar' : 'Editar';
    },
    isRouteCheckbox() {
      switch (this.$route.name) {
        case 'violenceFam':
          return true;
        case 'substances':
          return true;
        case 'violenceSoc':
          return true;
        case 'academic':
          return true;
        case 'labor':
          return true;
        case 'violence':
          return true;
        default:
          return false;
      }
    },
    isRouteFormExten() {
      switch (this.$route.name) {
        case 'violenceFam':
          return 'violenceFam';
        case 'substances':
          return 'substances';
        case 'violenceSoc':
          return 'violenceSoc';
        case 'academic':
          return 'academic';
        case 'labor':
          return 'labor';
        case 'membersfam':
          return 'membersfam';
        case 'basic-studies':
          return 'acadBasic';
        case 'superior-studies':
          return 'acadSuperior';
        case 'jobs':
          return 'jobs';
        case 'mental':
          return 'mental';
        case 'medical':
          return 'medical';
        case 'drugs':
          return 'drugs';
        case 'violence':
          return 'violence';
        case 'criminal':
          return 'criminal';
        case 'medications':
          return 'medications';
        case 'relevant-events':
          return 'relevant-events';
        case 'diagTreatment':
          return 'diagTreatment';
        default:
          return false;
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    update(editedItem, defaultItem) {
      this.$emit('update:editedItems', { ...editedItem });
      this.$emit('update:defaultItems', { ...defaultItem });
    },
    initialize() {
      this.dataCrud;
    },
    editItem(item) {
      this.editedIndex = this.dataCrud.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.dataCrud.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      const updated = this.dataCrud.filter((_, index) => index !== this.editedIndex);

      this.$emit('update:dataCrud', updated);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      const base = Array.isArray(this.dataCrud) ? this.dataCrud : [];
      let updated;

      if (this.editedIndex > -1) {
        updated = base.map((item, index) =>
          index === this.editedIndex ? { ...item, ...this.editedItem } : item
        );
      } else {
        updated = [...base, { ...this.editedItem }];
      }

      this.$emit('update:dataCrud', updated);
      this.close();
    }
  },
};
</script>

<style>
.font-class-name {
  font-size: 3px !important;
}
</style>
